








import { Component, Vue } from "vue-property-decorator";
import Efemerides from "@/components/Web/Efemerides.vue";

@Component({
  components: {
    Efemerides
  },
  meta: {
    // sets document title
    title: "Efemérides - Maipú Sustentable",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Revisa aquí todo sobre reciclaje y sustentabilidad"
      },
      keywords: { name: "keywords", content: "Maipú" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class EfemeridesView extends Vue {
  private mounted() {
    document.title = "Efemérides - Maipú Sustentable";
  }
}
